import React from 'react';
import ReactDOM from 'react-dom';
import { getContainer } from './getContainer';

/**
 * Creates a [portal](https://reactjs.org/docs/portals.html) given a parent element and any renderable React children
 * @param children Content to be embedded
 * @param container Element that will contain `children`
 * @returns `container` containing `children`, or children as `React.Fragment`
 * @example
 * import { renderPortal } from '@adsk/alloy-react-helpers';
 *
 * const Portal = ({ children, container }) => renderPortal(children, container);
 * @see Portal
 */
const renderPortal = (children, container) => {
  if (container) {
    const ref = getContainer(container);
    if (ref instanceof HTMLElement) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, ref));
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default renderPortal;
//# sourceMappingURL=renderPortal.js.map